"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = exports.random = exports.upperFirst = exports.get = exports.mergeWith = exports.merge = exports.omit = exports.isNil = exports.defaultTo = void 0;
// Copied lodash implementation
const defaultTo = (value, defaultValue) => {
    return (value == null || value !== value) ? defaultValue : value;
};
exports.defaultTo = defaultTo;
// Copied lodash implementation
const isNil = (value) => {
    return value == null;
};
exports.isNil = isNil;
// Custom implementation
const omit = (obj, keysToOmit) => {
    if (!obj)
        return {};
    const keysArray = Array.isArray(keysToOmit) ? keysToOmit : [keysToOmit];
    return Object.keys(obj)
        .filter((key) => !keysArray.includes(key))
        .reduce((result, key) => {
        result[key] = obj[key];
        return result;
    }, {});
};
exports.omit = omit;
// Custom implementation
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function baseMerge(target, sources, customizer) {
    for (const source of sources) {
        for (const key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                const srcValue = source[key];
                const tgtValue = target[key];
                const result = customizer ? customizer(tgtValue, srcValue, key, target, source) : undefined;
                if (result === undefined) {
                    if (srcValue && typeof srcValue === 'object' && !Array.isArray(srcValue) &&
                        tgtValue && typeof tgtValue === 'object' && !Array.isArray(tgtValue)) {
                        baseMerge(tgtValue, [srcValue], customizer);
                    }
                    else {
                        if (srcValue || !target[key]) {
                            target[key] = srcValue;
                        }
                    }
                }
                else {
                    target[key] = result;
                }
            }
        }
    }
    return target;
}
// Custom implementation
const merge = (target, ...sources) => {
    return baseMerge(target, sources);
};
exports.merge = merge;
// Custom implementation
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
const mergeWith = (target, customizer, ...sources) => {
    return baseMerge(target, sources, customizer);
};
exports.mergeWith = mergeWith;
// Custom implementation
const get = (object, path, defaultValue) => {
    if (object == null)
        return defaultValue;
    const keys = Array.isArray(path) ? path : path.split('.');
    let result = object;
    for (const key of keys) {
        if (result == null || typeof result !== 'object' || !(key in result)) {
            return defaultValue;
        }
        result = result[key];
    }
    return result === undefined ? defaultValue : result;
};
exports.get = get;
// Custom implementation
const upperFirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.upperFirst = upperFirst;
// Custom implementation
const random = (lower = 0, upper = 1, floating) => {
    // Ensure lower and upper are in the correct order
    if (lower > upper) {
        [lower, upper] = [upper, lower];
    }
    // Determine if we need a floating number
    // If floating is true OR lower or upper are not integers, produce a float
    const needFloat = floating === true || !Number.isInteger(lower) || !Number.isInteger(upper);
    if (needFloat) {
        return Math.random() * (upper - lower) + lower;
    }
    else {
        // Return integer in the inclusive range [lower, upper]
        return Math.floor(Math.random() * (upper - lower + 1)) + lower;
    }
};
exports.random = random;
// Custom implementation
const isFunction = (value) => {
    return typeof value === 'function';
};
exports.isFunction = isFunction;
//# sourceMappingURL=helperFunctions.js.map